import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../models/action/core';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/messages';
import ContactListItem from './contactListItem';
import GroupListItem from './groupListItem';
import { IContact, IGroup } from '../../models/pages/messages';
import Loading from '../../components/loading/loading';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('Contacts Column');
let _common: Common;
export class CContactList extends Component<any, any> {
    public state = {
        users: {
            skip: 0,
            take: 20,
            keyword: undefined,
            hasMore: true
        },
        groups: {
            skip: 0,
            take: 20,
            keyword: undefined,
            hasMore: true
        },
        currentTab: 'contacts',
        showSearch: false,
        query: '',
        showMoreUsersCount: 20,
        showMoreGroupCount: 20,

    };
    searchInput: HTMLInputElement | null = null;

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    componentDidMount() {
        this.props.dispatch(
            Actions.getContactsAction({
                skip: this.state.users.skip,
                take: this.state.users.take,
                keyword: '',
                spinnerId: 'getContactsAction',
                spinnerType: 'get'
            })
        );

        this.props.dispatch(
            Actions.getGroupsAction({
                skip: this.state.groups.skip,
                take: this.state.groups.take,
                keyword: '',
                spinnerId: 'getGroupsAction',
                spinnerType: 'get'
            })
        );
    }

    componentDidUpdate() {
        if (this.state.showSearch && this.searchInput) {
            this.searchInput.focus();
        }
    }

    updateQuery = (query: string) => {
        this.setState({ users: this.state.users, currentTab: this.state.currentTab, showSearch: true, query });
    };

    showSearch = () => {
        this.setState({
            users: this.state.users,
            currentTab: this.state.currentTab,
            showSearch: true,
            query: this.state.query
        });
    };
    hideSearch = () => {
        this.setState({
            users: this.state.users,
            groups: this.state.groups,
            currentTab: this.state.currentTab,
            showSearch: false,
            query: ''
        });

        this.triggerSearch(this.state.currentTab, '');
    };

    isInSearchMode = () => {
        return this.state.query && this.state.query.length > 0 && this.state.showSearch;
    };

    onSearch = (e: any) => {
        if (e.key === 'Enter') {
            this.triggerSearch(this.state.currentTab, this.state.query);
        }
    };

    onContactsScrollDetected = () => {

        this.props.dispatch(
            Actions.getContactsAction({
                take: 0,
                skip: this.state.showMoreUsersCount,
                keyword: '',
                spinnerId: 'getContactsAction',
                spinnerType: 'get'
            })
        );

    };

    showMoreOnContactsClick = () => {
        this.setState((prevState: any) => ({ showMoreUsersCount: prevState.showMoreUsersCount + 20 }), () => {
            this.onContactsScrollDetected();
        });
    }

    onGroupsScrollDetected = () => {

        this.props.dispatch(
            Actions.getGroupsAction({
                take: 0,
                skip: this.state.showMoreGroupCount,
                keyword: '',
                spinnerId: 'getGroupsAction',
                spinnerType: 'get'
            })
        );
    };


    showMoreOnGroupClick = () => {
        this.setState((prevState: any) => ({ showMoreGroupCount: prevState.showMoreGroupCount + 20 }), () => {
            this.onGroupsScrollDetected();
        });
    }

    triggerSearch = (tabName: string, query: string) => {
            this.props.dispatch(
                Actions.getContactsAction({
                    take: 100,
                    skip: 0,
                    keyword: query,
                    spinnerId: 'getContactsAction',
                    spinnerType: 'get'
                })
            );
            this.props.dispatch(
                Actions.getGroupsAction({
                    skip: 0,
                    take: 100,
                    keyword: query,
                    spinnerId: 'getGroupsAction',
                    spinnerType: 'get'
                })
            );
    };

    onSearchTextChange = (event: any) => {
        this.updateQuery(event.target.value);
    };

    getContacts = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_CONTACTS_MESSAGES_CLICKED',
            label: 'G_CONTACTS_MESSAGES_CLICKED',
            nonInteraction: true,
        });
        this.setState({
            users: this.state.users,
            currentTab: 'contacts',
            showSearch: this.state.showSearch,
            query: this.state.query
        });
    };

    getGroups = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_GROUPS_MESSAGES_CLICKED',
            label: 'G_GROUPS_MESSAGES_CLICKED',
            nonInteraction: true,
        });
        this.setState({
            users: this.state.groups,
            currentTab: 'groups',
            showSearch: this.state.showSearch,
            query: this.state.query
        });
    };

    loading(start: number, length: number) {
        const loadingSpaces = 44;
        const rows = [];
        for (let index = start; index < length + start; index++) {
            rows.push(
                <>
                    <circle cx="24" cy={24 + (loadingSpaces * index)} r="16" />
                    <rect x="52" y={20 + (loadingSpaces * index)} rx="3" ry="3" width="70%" height="10" />
                </>
            );
        }

        return rows;
    }



    changeActive = () => {

        const item = document.getElementById('currentChatListPanel');
        const itemContact = document.getElementById('contactListPanel');
        if (item && itemContact) {
            item.style.display = 'block';
            itemContact.style.display = 'none';

        }
    }
    public render() {
        return (
            <div className="main-sidebar" id="chatContactList" >
                <ul>
                    <li data-active="active" className="mt-0 position-relative">
                        <div className="d-flex justify-content-between align-items-center mobile-navbar chat-contact-list">
                            <div className="d-flex align-items-center">
                                <button className='transparent-button d-flex justify-content-center align-items-center' type="button" onClick={this.changeActive} id="backToMesaageList">
                                    <i className="material-icons" style={{ color: "black" }}>arrow_back</i>
                                </button>
                                <span style={{ fontSize: '1.25em', fontWeight: '500', marginLeft: '3px' }}>{T.t('r_new_message')}</span>
                            </div>

                            <div className="options d-inline-flex align-items-center">
                                <a data-toggle="collapse" onClick={this.showSearch}>
                                    <i className="material-icons">search</i>
                                </a>
                            </div>
                        </div>
                        <div id="searchContacts" className={'search' + (this.state.showSearch ? ' collapse show' : ' collapse')}>
                            <div className="input-group">
                                <div data-toggle="collapse" className="input-group-prepend" onClick={this.hideSearch}>
                                    <div className="input-group-text">
                                        <i className="material-icons">arrow_back</i>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inlineFormInputGroup"
                                    placeholder={T.t('r_gen_search')}
                                    onKeyDown={this.onSearch}
                                    onChange={this.onSearchTextChange}
                                    ref={e => (this.searchInput = e)}
                                    value={this.state.query}
                                />
                            </div>
                        </div>
                    </li>
                </ul>
                <div className="announcementTabs">
                    <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="contactTabs" role="tablist">
                        <li className="nav-item">
                            <a className={'nav-link ' + (this.state.currentTab === 'groups' ? 'active show' : '')} onClick={this.getGroups} tabIndex={0}>
                                {T.t('r_groups')}
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={'nav-link ' + (this.state.currentTab === 'contacts' ? 'active show' : '')}
                                onClick={this.getContacts}
                                tabIndex={0}
                            >
                                {T.t('r_contacts')}
                            </a>
                        </li>
                    </ul>
                </div>
                <div
                    className={'message-people-list ' + (this.state.currentTab === 'contacts' ? 'hidden' : '')}

                >
                    <Loading spinnerId={'getGroupsAction'} height={'100%'}>
                        <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                style={{ width: '100%', height: '100%' }}
                                preserveAspectRatio="xMinYMin meet"
                            >
                                {this.loading(0, 10)}
                            </ContentLoader>
                        </div>
                    </Loading>
                    <ol id="getGroupsAction_Content" className="options-bulets">
                        {this.props.groups && this.props.groups.length > 0 ? (
                            this.props.groups.map((item: IGroup) => (
                                <li className="" key={item.classId}>
                                    <GroupListItem {...item} dispatch={this.props.dispatch} />
                                </li>
                            ))
                        ) : (
                            <div className="ml-3 mt-3 small">
                                {this.isInSearchMode()
                                    ? T.t('r_no_record_was_found_in_the_search_result')
                                    : T.t('r_no_group_course_branch_in_group_list')}
                            </div>
                        )}
                        {this.props.groups && this.props.groupsTotalCount >= 20 && (
                            <div className="modal-body small" onMouseDown={this.showMoreOnGroupClick}><div>
                                <label style={{ cursor: 'pointer', textTransform: 'none' }} className='small'>{T.t('r_gen_show_more')}</label>
                            </div></div>
                        )}
                    </ol>
                </div>
                <div
                    className={'message-people-list ' + (this.state.currentTab === 'groups' ? 'hidden' : '')}
                >
                    <Loading spinnerId={'getContactsAction'} height={'100%'}>
                        <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                style={{ width: '100%', height: '100%' }}
                                preserveAspectRatio="xMinYMin meet"
                            >
                                {this.loading(0, 10)}
                            </ContentLoader>
                        </div>
                    </Loading>
                    <ol id="getContactsAction_Content" className="options-bulets">
                        {this.props.users && this.props.users.length > 0 ? (
                            this.props.users.map((item: IContact) => (
                                <li className="" key={item.userId}>
                                    <ContactListItem message={this.props.message} {...item} dispatch={this.props.dispatch} />
                                </li>
                            ))
                        ) : (
                            <div className="ml-3 mt-3 small">
                                {this.isInSearchMode()
                                    ? T.t('r_no_record_was_found_in_the_search_result')
                                    : T.t('r_no_contact_in_contact_list')}
                            </div>
                        )}

                        {this.props.users && this.props.usersTotalCount >= 20 && (
                            <div className="modal-body small" onMouseDown={this.showMoreOnContactsClick}><div>
                                <label style={{ cursor: 'pointer', textTransform: 'none' }} className='small'>{T.t('r_gen_show_more')}</label>
                            </div></div>
                        )}
                    </ol>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        message: state.message,
        users: state.message.users,
        groups: state.message.groups,
        usersTake: state.message.usersTake,
        usersSkip: state.message.usersSkip,
        groupsTake: state.message.groupsTake,
        groupsSkip: state.message.groupsSkip,
        usersTotalCount: state.message.usersTotalCount,
        groupsTotalCount: state.message.groupsTotalCount
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.message === prev.message &&
        next.message.users === prev.message.users &&
        next.message.groups === prev.message.groups &&
        next.message.usersTotalCount === prev.message.usersTotalCount &&
        next.message.groupsTotalCount === prev.message.groupsTotalCount &&
        next.message.usersTake === prev.message.usersTake &&
        next.message.usersSkip === prev.message.usersSkip &&
        next.message.groupsTake === prev.message.groupsTake &&
        next.message.groupsSkip === prev.message.groupsSkip &&
        !!next.message.users &&
        !!prev.message.users &&
        next.message.users.length === prev.message.users.length &&
        !!next.message.groups &&
        !!prev.message.groups &&
        next.message.groups.length === prev.message.groups.length;
    return ret;
};

const ContactList = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CContactList);

export default ContactList;
